import { Typography, Box } from "@mui/material";
import { IEvent } from "../../Interfaces";
import { SessionCountdown } from "./SessionCountdown";

interface EventCountdownProps {
  event: IEvent;
  variant?: "body1" | "body2" | "caption";
}

export const EventCountdown = ({
  event,
  variant = "body2",
}: EventCountdownProps) => {
  // Find the first race session
  const raceSession = event.Sessions?.find(
    (session) => session.SessionType?.toLowerCase() === "race",
  );

  // If no race session exists, don't display anything
  if (!raceSession) {
    return null;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={0.5}
      sx={{
        lineHeight: 1,
        margin: 0,
        padding: 0,
      }}
    >
      <Typography
        variant={variant}
        color="text.secondary"
        sx={{ lineHeight: 1, margin: 0, whiteSpace: "nowrap" }}
      >
        Race:
      </Typography>
      <SessionCountdown
        startTime={raceSession.StartTime}
        timeZone={event.Site?.TimeZoneOffset}
        variant={variant}
      />
    </Box>
  );
};
